// extracted by mini-css-extract-plugin
export default {"root":"q8QU4pyiSslED1ar10Ew","close":"inEZpVn6QRo1pLSiqpfL","root--fill":"_IUdp7sxiFeBAJ6qSQBK","root--hide-close":"xMCb8elIfAw9eZD5OF04"};